function About() {
    return <div id="about" className="flex flex-col justify-center py-20 px-5 xl:px-56 h-screen">
        <div className="flex pb-2">
            <h1 className="text-2xl font-bold">ABOUT ME</h1>
            <div className="block relative border-t border-black -bottom-5 ml-3 w-full max-w-screen-sm">&nbsp;</div>
        </div>
        <div className="flex">
            <div>
                <p className="pb-3">
                    Hello! My name is <b>Shun Jie</b> and I love making things!
                </p>
                <p className="pb-3">
                    My interest in computers started during primary school when I tried making a scripting using the <a className="underline" href="https://en.wikipedia.org/wiki/Lego_Mindstorms_NXT"><b>LEGO NXT</b></a>.
                    Joining the school team and participating in competitions, made me interested in building things and that passion has stuck with me till this day.
                </p>
                <p className="pb-3">
                    Fast forward today and I've had the chance to work with <a href="https://www.singtel.com/" target="_blank" rel="noreferrer"><b>Singtel</b></a>, helping to ease the load of their engineers,
                    through the power of automation!
                </p>
                <p className="pb-3">
                    I also recently launched an API that can be found <a className="underline" href="https://github.com/Ruin9999/leetcode-api" target="_blank" rel="noreferrer">here</a>,
                    to futher ease the process of accessing data from <a href="https://leetcode.com" target="_blank" rel="noreferrer"><b>Leetcode</b></a>.
                </p>
            </div>
        </div>
        <div className="w-full max-w-screen-sm">
            Here are some technologies that I've been working with recently:
            <ul className="grid grid-cols-3 pt-2 gap-2 underline">
                <li>▹<code><small>Javascript</small></code></li>
                <li>▹<code><small>Typescript</small></code></li>
                <li>▹<code><small>React</small></code></li>
                <li>▹<code><small>NodeJS</small></code></li>
                <li>▹<code><small>ElectronJS</small></code></li>
                <li>▹<code><small>ExpressJS</small></code></li>
            </ul>
        </div>
    </div>
}

export default About;